import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {useNullableProcedureFlowchartValidationContext} from 'procedures/processes/useNullableProcedureFlowchartValidationContext';

import {ApplicationFlowchartValidationContextResult} from './ApplicationFlowchartValidationContextResult';
import {StaticTemplateFlowchart} from './processFlowchartConfigEditorConstants';

export type {ApplicationFlowchartValidationContextResult};

/**
 * Hook to compute validation context for flowchart validation based on execution type.
 *
 * This hook is platform-agnostic and delegates to application-specific implementations
 * based on the execution type. Application teams should provide their own implementations
 * for their specific execution types.
 *
 * @param executionType The execution type of the flowchart
 * @param draftFlowchartConfig The draft flowchart configuration
 * @returns Validation context object plus readiness flag and context key, or empty object if no application-specific implementation exists
 */
export function useApplicationFlowchartValidationContext(
  executionType: ProcessExecutionType,
  draftFlowchartConfig: StaticTemplateFlowchart
): ApplicationFlowchartValidationContextResult {
  const procedureValidationContextResult =
    useNullableProcedureFlowchartValidationContext(draftFlowchartConfig);

  if (executionType === ProcessExecutionType.PROCEDURE) {
    return procedureValidationContextResult;
  }

  return {
    context: {},
    isLoaded: true,
    contextKey: 'default',
  };
}
